import React, { useState, useMemo } from "react";
import { useSubscribe } from '../../hooks';
import { queue$ } from '../../observables/queue';
import { filter } from 'rxjs/operators';
import { whereEq, last, pipe, split } from 'ramda';
import { QueueEventType, QueueType } from '../../shared/types';
import { Progress, CircleProgress, Tooltips } from '../../ui/components';
import styles from './Queue.less';
import { t } from 'i18next';
const captions = {
    [QueueType.Copy]: { msg: 'copying', icon: 'file_copy' },
    [QueueType.Move]: { msg: 'moving', icon: 'file_copy' },
    [QueueType.Download]: { msg: 'downloading', icon: 'download' },
    [QueueType.Upload]: { msg: 'uploading', icon: 'upload' },
    [QueueType.Remove]: { msg: 'deleting', icon: 'delete' }
};
export default function ({ id, type, connection, active }) {
    const [count, setCount] = useState(0);
    const [total, setTotal] = useState(1);
    const [done, setDone] = useState(0);
    useSubscribe(() => queue$
        .pipe(filter(whereEq({ id })))
        .subscribe(({ event }) => {
        if (event.type == QueueEventType.Update) {
            const { totalCnt, doneCnt, totalSize, doneSize } = event.state;
            setCount(totalCnt - doneCnt);
            setTotal(type == QueueType.Remove || QueueType.Move ? totalCnt : totalSize);
            setDone(type == QueueType.Remove || QueueType.Move ? doneCnt : doneSize);
        }
    }), [id]);
    const msg = useMemo(() => {
        const c = localStorage.getItem(connection);
        const conn = c
            ? pipe(split('/'), last)(c)
            : connection;
        return t(captions[type].msg, { count, conn });
    }, [count]);
    return React.createElement("div", { className: active ? styles.active : styles.inactive }, active ?
        React.createElement(React.Fragment, null,
            React.createElement("span", { dangerouslySetInnerHTML: { __html: msg } }),
            React.createElement("div", { className: styles.progress },
                React.createElement(Progress, { percent: Math.round(done / total * 100) }),
                React.createElement(Tooltips, null,
                    React.createElement("span", { className: "icon", onClick: () => window.f5.stop(id), "data-tooltip": "Stop" }, "stop_circle")))) :
        React.createElement(CircleProgress, { percent: Math.round(done / total * 100) },
            React.createElement("i", { className: 'icon' }, captions[type].icon)));
}
